module.exports = __webpack_public_path__ + "img/doc.ab17029c.png";